import { TranslationType } from '../types';

export const ko: TranslationType = {
  common: {
    wallets: '지갑',
    dashboard: '대시보드',
    settings: '설정',
    darkMode: '다크 모드',
    lightMode: '라이트 모드',
    language: '언어',
    english: 'English',
    chinese: '中文',
    russian: 'Русский',
    german: 'Deutsch',
    indonesian: 'Bahasa Indonesia',
    korean: '한국어',
    japanese: '日本語',
    thai: 'ภาษาไทย',
    blog: '블로그'
  },
  footer: {
    quickLinks: '빠른 링크',
    about: '소개',
    terms: '이용약관',
    privacy: '개인정보 보호정책',
    contact: '문의하기',
    copyright: '© 2025 XCH.live. 모든 권리 보유.',
    description: 'Chia 블록체인 지갑을 위한 고급 모니터링 플랫폼. 실시간 거래 알림을 받고, 즉각적인 알림으로 자산을 보호하며, 콜드 월렛 활동을 모니터링하세요.',
    connectWithUs: '연락하기',
    builtBy: 'Spacescan.io 팀이 ❤️로 만들었습니다'
  },
  home: {
    hero: {
      title: 'Chia 콜드 월렛 모니터링',
      subtitle: 'XCH 거래에 대한 즉각적인 이메일 알림 받기',
      input: {
        label: '마스터 키(96자) 또는 XCH 주소 입력',
        placeholder: '마스터 키(96자) 또는 XCH 주소 입력',
        helper: '모니터링을 시작하려면 마스터 키 또는 XCH 주소를 입력하세요'
      },
      buttons: {
        cardprefix: '$12',
        card: '카드로 결제',
        strprefix: '50% OFF',
        str: 'STR로 결제'
      }
    },
    features: {
      title: '늦기 전에 Chia를 보호하세요',
      subtitle: '해커를 기다리지 마세요 - 24/7 모니터링으로 콜드 월렛을 적극적으로 보호하세요',
      vault: {
        title: 'Vault 및 Clawback 활성화',
        description: '고급 볼트 및 클로백 기능으로 자산 보호'
      },
      monitoring: {
        title: '안전한 모니터링',
        description: '개인 키를 노출하지 않고 콜드 월렛 활동 추적'
      },
      alerts: {
        title: '즉각적인 알림',
        description: '모든 거래에 대한 즉각적인 이메일 알림 수신'
      },
      recovery: {
        title: '자금 회수',
        description: '클로백 기간 동안 승인되지 않은 거래에서 자금 회수'
      }
    },
    metrics: {
      title: '숫자로 보는 우리의 영향력',
      walletsMonitored: {
        label: '모니터링된 지갑'
      },
      alertsSent: {
        label: '전송된 알림'
      },
      transactionsAnalyzed: {
        label: '분석된 거래'
      }
    },
    testimonials: {
      title: '사용자들의 이야기',
      items: [
        {
          quote: 'XCH.live는 제 콜드 월렛이 24/7 모니터링되고 있다는 것을 알고 마음의 평화를 줍니다. 즉각적인 알림은 게임 체인저입니다.',
          author: '마이클 첸',
          role: 'Chia 파머'
        },
        {
          quote: '설정이 믿을 수 없을 만큼 쉽고 모니터링이 안정적입니다. 제 Chia 자산에 필요한 바로 그것입니다.',
          author: '사라 존슨',
          role: '크립토 투자자'
        },
        {
          quote: 'Chia 지갑 모니터링을 위한 최고의 솔루션입니다. 이메일 알림이 빠르고 대시보드가 매우 직관적입니다.',
          author: '데이비드 김',
          role: '블록체인 개발자'
        }
      ]
    }
  },
  settings: {
    title: '설정',
    subtitle: '지갑 설정 관리',
    notifications: {
      title: '알림',
      emailNotifications: '이메일 알림',
      emailDescription: '거래 업데이트를 이메일로 받기',
      threshold: {
        title: '거래 임계값',
        description: '알림을 보낼 최소 XCH 금액 (최소 1 XCH)'
      }
    },
    walletInfo: {
      title: '지갑 정보',
      masterKey: '마스터 키'
    },
    actions: {
      save: '변경사항 저장',
      delete: '지갑 삭제'
    },
    messages: {
      success: '설정이 성공적으로 저장되었습니다!',
      error: {
        generic: '설정을 업데이트할 수 없습니다',
        threshold: '임계값은 1 XCH 이상이어야 합니다',
        delete: '지갑을 삭제할 수 없습니다'
      },
      deleteConfirm: '이 지갑을 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.'
    }
  },
  wallets: {
    title: '내 지갑',
    subtitle: '콜드 월렛 관리 및 모니터링',
    status: {
      active: '모니터링 활성',
      pending: '결제 대기 중',
      expired: '모니터링 만료됨',
      timeLeft: {
        days: '{{days}}일 {{hours}}시간 남음',
        hours: '{{hours}}시간 {{minutes}}분 남음',
        minutes: '{{minutes}}분 남음',
        lessThanMinute: '1분 미만 남음'
      }
    },
    actions: {
      payWithCard: '카드로 결제',
      completeCryptoPayment: '암호화폐 결제 완료',
      renewMonitoring: '모니터링 갱신',
      dashboard: '대시보드',
      settings: '설정',
      addFirstWallet: '첫 번째 지갑 추가',
      removeWallet: '지갑 제거'
    },
    messages: {
      noWallets: '지갑을 찾을 수 없습니다'
    }
  },
  dashboard: {
    title: '지갑 대시보드',
    tabs: {
      events: '이벤트',
      addresses: '주소'
    },
    addresses: {
      totalAddresses: '총 주소: {{count}}',
      index: '인덱스',
      address: '주소',
      actions: '작업'
    },
    events: {
      loadMore: '더 보기',
      noEvents: '이벤트를 찾을 수 없습니다',
      sent: '전송됨',
      received: '수신됨',
      spent: '사용됨',
      pending: '대기 중',
      failed: '실패',
      showDetails: '상세 보기',
      hideDetails: '상세 숨기기',
      block: '블록',
      viewOnSpacescan: 'Spacescan에서 보기',
      transactionHash: '거래 해시',
      nftsReceived: 'NFT 수신됨',
      nftsSent: 'NFT 전송됨',
      nftTransaction: 'NFT 거래',
      viewNFTDetails: 'NFT 상세 보기',
      receivedNFTs: '수신된 NFT',
      sentNFTs: '전송된 NFT'
    }
  },
  faq: {
    title: '자주 묻는 질문',
    security: {
      question: '모니터링 서비스는 얼마나 안전한가요?',
      answer: '우리의 서비스는 모니터링 목적으로 공개 마스터 키만을 사용하여 최고 수준의 보안 표준으로 운영됩니다. 우리는 개인 키나 지출 능력에 접근할 수 없으므로 귀하의 자금은 완전히 안전합니다. 우리는 BLS-12-381 암호화 표준을 사용하며, 여기서 개인 키(32바이트)와 공개 키(48바이트)는 분리되어 안전하게 유지됩니다.',
      learnMore: 'Chia의 BLS 키에 대해 자세히 알아보기 →'
    },
    monitoring: {
      question: '거래 모니터링 빈도는 어떻게 되나요?',
      answer: '우리 시스템은 Chia 블록체인의 각 새로운 블록을 확인하여 실시간으로 거래를 모니터링합니다. 모든 모니터링되는 주소에서 활동을 추적하여 지갑에 영향을 미치는 모든 거래에 대해 즉각적인 알림을 제공합니다.'
    },
    masterKey: {
      question: '내 지갑의 공개 마스터 키는 어떻게 찾나요?',
      answer: 'Chia GUI 또는 CLI 지갑을 통해 공개 마스터 키에 접근할 수 있습니다. 이 과정을 안내하는 자세한 비디오 튜토리얼을 준비했습니다. 중요: 개인 키나 시드 구문은 절대 공유하지 마세요 - 우리의 모니터링 서비스에는 공개 마스터 키만 필요합니다.',
      videoTitle: '공개 마스터 키 찾는 방법',
      learnMore: '키 찾기에 대한 자세한 가이드 읽기 →'
    },
    addresses: {
      question: '마스터 키로 몇 개의 주소가 모니터링되나요?',
      answer: '우리 서비스는 마스터 키와 연결된 100개의 파생 주소를 모니터링하여 지갑의 거래 활동을 완벽하게 커버합니다.'
    },
    singleAddress: {
      question: '마스터 키 대신 특정 주소만 모니터링할 수 있나요?',
      answer: '네, 우리 서비스는 개별 주소 모니터링에 대한 유연성을 제공합니다. 여러 주소를 모니터링하기 위해 마스터 키를 사용하는 대신 단일 특정 주소를 모니터링하도록 선택할 수 있습니다.'
    },
    notifications: {
      question: '알림은 어떻게 설정하나요?',
      answer: '지갑 설정을 통해 이메일 알림을 완전히 제어할 수 있습니다. 우리의 대시보드는 모니터링 요구사항에 맞게 알림 기본 설정을 조정할 수 있는 옵션을 제공합니다.'
    },
    vault: {
      question: 'Chia vault는 무엇이고 어떻게 작동하나요?',
      answer: 'Chia vault는 디지털 자산에 대한 강화된 보호를 제공하는 고급 보안 기능입니다. 멀티시그 요구사항이나 시간 지연 거래와 같은 추가 보안 조치를 구현합니다. 볼트는 자산 보관을 코인과 분리하고 거래 승인을 위해 여러 서명(m-of-n 멀티시그)을 요구할 수 있습니다.',
      learnMore: 'Chia Vaults에 대해 자세히 알아보기 →'
    },
    clawback: {
      question: 'Chia의 clawback 기능은 무엇인가요?',
      answer: 'Clawback은 특정 기간 동안 거래를 취소할 수 있게 해주는 Chia의 보안 기능입니다. 활성화되면 수신자는 이체된 자금에 접근하기 전에 클로백 기간이 만료될 때까지 기다려야 하며, 이는 거래에 추가적인 보안 계층을 제공합니다.'
    },
    vaultSupport: {
      question: '서비스가 vault와 clawback 기능을 지원하나요?',
      answer: '우리는 vault와 clawback을 사용하는 거래를 모니터링하지만, 이러한 기능을 직접 관리하지는 않습니다. 이러한 기능은 지갑 생성 시 설정되어야 합니다. 우리 서비스는 주소에 대한 거래 모니터링과 알림 전달에 중점을 둡니다.'
    },
    tokens: {
      question: 'Chia 토큰에 대한 모니터링을 제공하나요?',
      answer: '현재 우리의 모니터링 서비스는 XCH 거래에만 중점을 두고 있습니다. 토큰 모니터링 기능은 현재 서비스 제공에 포함되어 있지 않습니다.'
    },
    nft: {
      question: 'NFT 거래 모니터링이 가능한가요?',
      answer: '현재 우리 서비스는 XCH 거래 모니터링에 특화되어 있습니다. NFT 거래 모니터링은 현재 서비스 기능에 포함되어 있지 않습니다.'
    },
    subscription: {
      question: '구독 및 환불 정책은 어떻게 되나요?',
      answer: '우리 서비스는 구독 기반으로 제공됩니다. 모니터링 서비스의 즉각적인 특성으로 인해 서비스가 활성화된 후에는 환불을 제공하지 않습니다. 구독하기 전에 서비스 약관을 이해했는지 확인해 주세요.'
    }
  },
  notFound: {
    title: '페이지를 찾을 수 없습니다',
    lostMessage: '당신의 Chia가 이 페이지처럼 - 공허 속으로 사라지지 않게 하세요!',
    securityMessage: '홈으로 돌아가서 XCH를 24/7 안전하게 모니터링하는 방법을 알아보세요.',
    protectButton: 'Chia 보호하기'
  }
}; 